const runAllMutationsWithArgs = async (mutations) => {
  // mutations = [ { mutation: someMutation, input: input }, ... ]
  return Promise.all(
    mutations.map(({ mutation, input }) =>
      mutation.mutateAsync(input)
    )
  );
}

export {runAllMutationsWithArgs}